import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Account, Subscription } from "@core/store/account/account.model";

const API_ENDPOINT = environment.API_ENDPOINT + "/account";

@Injectable()
export class AccountService {
  constructor(private http: HttpClient) {}

  getAccount(): Observable<Account> {
    return this.http.get<Account>(API_ENDPOINT);
  }

  updateBillingInfo(
    token: string,
    threeDSecureToken: string,
  ): Observable<Account> {
    return this.http.post<Account>(`${API_ENDPOINT}/billing-info`, {
      token,
      threeDSecureToken,
    });
  }

  createSubscription(
    planCode: string,
    billingInfoToken?: string,
    threeDSecureToken?: string,
  ): Observable<Subscription> {
    const params = { planCode };

    if (billingInfoToken) {
      params["billingInfoToken"] = billingInfoToken;
    }

    if (threeDSecureToken) {
      params["threeDSecureToken"] = threeDSecureToken;
    }

    return this.http.post<Subscription>(
      `${API_ENDPOINT}/subscriptions`,
      params,
    );
  }

  changeSubscription(uuid: string, planCode: string): Observable<any> {
    return this.http.put<any>(`${API_ENDPOINT}/subscriptions/${uuid}`, {
      planCode,
    });
  }

  // TODO: typing
  cancelSubscription(uuid: string): Observable<any> {
    return this.http.delete<any>(`${API_ENDPOINT}/subscriptions/${uuid}`);
  }

  // TODO: typing
  redeemCoupon(code: string): Observable<any> {
    return this.http.post<any>(`${API_ENDPOINT}/coupons`, { code });
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/account/account.service.ts